<template>
    <div class="w-full">
        <ul v-if="!siblings" :class="[page?.class]">
            <li v-for="p in page?.page_objects" :key="p.id" :class="p.class">
                <component :is="getComponent(p.objectable_type)" :key="p.id" :comp-object="p" :page="page" :auth="auth" />
            </li>
        </ul>
        <ul v-if="siblings" class="relative w-full flex flex-col items-center justify-start ">
            <li v-if="basedOnIndexOfSibling() != 0" >
                <div class="sidebar left">
                    <SubPageNavigation :subpage-title="subpage?.page_title" :page="page" :siblings="siblings" direction="prev" />
                </div>
            </li>
            <li v-for="p in page.page_objects" :key="p.id" :class="[p.class, 'w-full']">
                <component :auth="auth" :is="getComponent(p.objectable_type)" :key="p.id" :comp-object="p" :page="page" />
            </li>
            <li v-if="basedOnIndexOfSibling() < totalSiblings -1" class="sidebar right" >
                <SubPageNavigation :subpage-title="subpage?.page_title" :page="page" :siblings="siblings" direction="next" />
            </li>
        </ul>
    </div>
</template>

<script>
import {defineAsyncComponent} from "vue";
import { generalStore } from "@/stores/generalStore";
import { mapState, mapWritableState } from "pinia";
import SubPageNavigation from '@/components/SubPageNavigation.vue'
import { router } from "@inertiajs/vue3";

export default {
   name: "FillablePage",
   components: { SubPageNavigation },
   props: ['auth', 'page', 'subpage', 'siblings'],
   watch: {
        'page.hide_navigation': {
            handler(n) {
                this.hideNav=n;
            },
            deep: true,
            immediate: true
        }
   },
   computed: {
    ...mapState(generalStore, ['pageHeight', 'scrollY']),
        ...mapWritableState(generalStore, ['interval', 'hideNav', 'isTouchDevice', 'pointerBannerClosed']),
        subPageWithChildren() {
            if(this.page?.slug == 'portfolio') {
                return true;
            }else{
                return false;
            }
        },
        pageChildren() {
            return this.page?.children;
        },
        totalSiblings() {
            return this.siblings?.length ?? null;
        }
   },
   data() {
       return {
        pageIndex: 0
       }
   },
   mounted() {
    //if page has children but the last argument in the uri doesn't match the a child add the last argument by selectinfg the first child

        if(this.$page?.url?.split('/').length == 3 && this.page?.children?.find(pc => this.$page?.url.substring(this.$page?.url.lastIndexOf('/') + 1) !== pc.slug)) {
            //here
            router.visit(this.$page.url+'/'+this.pageChildren[0].slug);
        }
   },
    methods: {
        getComponent(type) {
            const clss=this.page?.page_objects?.find(o => ~o.class?.indexOf('full-gallery'));
            switch(true) {
                case type.indexOf('Gallery') > -1:
                    if(clss) {
                        return defineAsyncComponent(() => import('@/components/FullGallery.vue'));
                    }else{
                        return defineAsyncComponent(() => import('@/components/Gallery.vue'));
                    }
                case type.indexOf('Video') > -1:
                    return defineAsyncComponent(() => import('@/components/Video.vue'));
                case type.indexOf('MultiParagraph') > -1:
                    return defineAsyncComponent(() => import('@/components/MultiParagraph3.vue'));
                case type.indexOf('Paragraph') > -1:
                    return defineAsyncComponent(() => import('@/components/Paragraph.vue'));
                case type.indexOf('Carousel') > -1:
                    return defineAsyncComponent(() => import('@/components/Carousel3.vue'));
                case type.indexOf('Image') > -1:
                    return defineAsyncComponent(() => import('@/components/Image.vue'));
            }
        },
        basedOnIndexOfSibling() {
            return this.siblings?.findIndex(s=> s.slug == this.page?.slug);
        },
    }
}
</script>
<style lang="css">
.sidebar {
    @apply fixed top-1/2 -translate-y-1/2 flex flex-wrap items-center justify-center z-[500] pointer-events-auto;
    max-height: 200px;
    width: 4%;
}

.sidebar.left {
    left: 0;
}

.sidebar.right {
    right: 0;
}
</style>
